import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Tabs from "./components/Tabs";
import { LogisticAction } from "redux/actions";
import HomeTab from "logistic-integrations/components/HomeTab";

const Jeebly = ({ order, fetchOrderDetailsByID }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { jeeblyModal } = useSelector((state) => state.LogisticReducer);

  return (
    <HomeTab
      {...{
        order,
        fetchOrderDetailsByID,
        title: t("Delivery Using Jeebly"),
        isOpen: jeeblyModal,
        onClose: () => {
          dispatch(LogisticAction.toggleJeeblyModal(false));
        },
      }}
    >
      <Tabs
        {...{ order, fetchOrderDetailsByID }}
        setOpen={() => {
          dispatch(LogisticAction.toggleJeeblyModal(false));
        }}
      />
    </HomeTab>
  );
};

export default Jeebly;
